"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TermUtil_1 = require("./lib/TermUtil");
exports.getLiteralLanguage = TermUtil_1.getLiteralLanguage;
exports.getLiteralType = TermUtil_1.getLiteralType;
exports.getLiteralValue = TermUtil_1.getLiteralValue;
exports.quadToStringQuad = TermUtil_1.quadToStringQuad;
exports.stringQuadToQuad = TermUtil_1.stringQuadToQuad;
exports.stringToTerm = TermUtil_1.stringToTerm;
exports.termToString = TermUtil_1.termToString;
//# sourceMappingURL=index.js.map